<template>
    <div class="modl-tab-body">
        <div class="modl-body">
            <OfflineNotification message="SEARCH_MODAL.OFFLINE_ERROR" />
            <CheckDtVoucherForm />
        </div>

        <div class="modl-footer">
            <!-- Cancel button -->
            <button class="btn btn-lg btn-default cancel-btn"
                    @click.prevent="$emit('cancel')">
                {{ l('CANCEL') }}
            </button>
        </div>
    </div>
</template>

<script>
import CheckDtVoucherForm from '@/epos/vue/modals/Search/CheckDtVoucherForm';
import OfflineNotification from '@/epos/vue/components/Generic/OfflineNotification';

export default {
    components: {
        OfflineNotification,
        CheckDtVoucherForm,
    },

    emits: [
        'cancel',
    ],
};
</script>
